/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.

 GNU Taler is distributed in the hope that it will be useful, but WITHOUT ANY
 WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 A PARTICULAR PURPOSE.  See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with
 GNU Taler; see the file COPYING.  If not, see <http://www.gnu.org/licenses/>
 */

import type { VNode } from "preact";
import { useState } from "preact/hooks";
import { useIncomingTransfers, useInstanceKycStatus } from "../api/hooks.js";
import { MoneyInScreen, type MoneyInScreenProps } from "../screens/MoneyInScreen.js";

export function MoneyInRoute(props: MoneyInScreenProps): VNode {
  // The screen's account filter narrows the query, so the route has to know
  // which account is selected.
  const [paytoUri, setPaytoUri] = useState<string | undefined>(undefined);
  const { incoming, isLoading, resource: incomingResource, confirmTransfer, unconfirmTransfer } = useIncomingTransfers(paytoUri);
  const { kycData, resource: kycResource, liveError: kycLiveError } = useInstanceKycStatus(props.token);

  return (
    <MoneyInScreen
      {...props}
      incoming={incoming}
      incomingResource={incomingResource}
      isIncomingLoading={isLoading}
      onConfirmTransfer={confirmTransfer}
      onUnconfirmTransfer={unconfirmTransfer}
      onFilterAccountChange={setPaytoUri}
      liveKycData={kycData}
      kycResource={kycResource}
      kycLiveError={kycLiveError}
    />
  );
}
